export default "/images/vendor/flag-icon-css/flags/1x1/ec.svg?7be6ca137c0a396154ac29e4a1fcc6b5";